// types
import { i18nEaiMessages } from 'models/i18n';

// ==============================|| I18N SK MESSAGES ||============================== //

const skEaiMessages: i18nEaiMessages = {
  changeEmsMemberAccountSubscription: 'Úroveň služieb úspešne zmenená',
  createEmsParty: 'Subjekt úspešne vytvorený',
  updateEmsParty: 'Subjekt úspešne upravený',
  deleteEmsParty: 'Subjekt úspešne odstránený',
  createEmsMemberAccount: 'Účet subjektu úspešne vytvorený',
  updateEmsMemberAccount: 'Účet subjektu úspešne upravený',
  activateEmsMemberAccount: 'Účet subjektu úspešne obnovený',
  deactivateEmsMemberAccount: 'Účet subjektu úspešne zneplatntný',
  updateMarketParticipant: 'Účastník trhu úspešne upravený',
  addMarketParticipantCredentials: 'Prístupové údaje úspešne pridané',
  removeMarketParticipantCredentials: 'Prístupové údaje úspešne odobrané',
  createEmsMemberAccountUser: 'Používatel úspešne vytvorený',
  createDeliveryPoint: 'Odberné miesto (OOM) úspešne vytvorené',
  updateDeliveryPoint: 'Odberné miesto (OOM) úspešne upravené',
  updateDeliveryPointCharacteristics:
    'Charakteristiky pre OOM úspešne upravené',
  updateDeliveryPointGDSName: 'GDS meno úspešne upravené',
  enableUserAccount: 'Účet používateľa úspešne obnovený',
  disableUserAccount: 'Účet používateľa úspešne zneplatnený',
  resetUserPassword: 'Bola odoslaná výzva na zmenu hesla',
  updateUser: 'Účet používateľa úspešne upravený',
  deleteUser: 'Používateľ úspešne zmazaný',
  assignEmsMemberAccountUser:
    'Účet subjektu úspešne priradený k účtu používateľa.',
  unassignEmsMemberAccountUser:
    'Účet subjektu úspešne odobratý z účtu používateľa.',
  addUserRole: 'Používateľská rola úspešne pridaná',
  deleteUserRole: 'Používateľská rola úspešne odobraná.',
  updateBalanceGroup: 'Bilančná skupina úspešne upravená',
  updateBalanceGroupCharacteristics:
    'Charakteristiky pre bilančnú skupinu úspešne upravené',
  createDevice: 'Zariadenie úspešne vytvorené',
  updateDevice: 'Zariadenie úspešne upravené',
  assignGDS: 'Priradenie zariadenia ku komunikačnej bráne úspešne zmenené',
  registerGDSToDeliveryPoint: 'GDS vytvorená pre OOM',
  unassignGDSFromDeliveryPoint: 'GDS úspešne zneplatnená',
  updateDeviceCharacteristicGroupCharacteristics:
    'Vlastnosti zariadenia úspešne upravené',
  createDeviceCharacteristicGroup: 'Skupina zariadenia úspešne vytvorená',
  deleteDevice: 'Zariadenie úspešne odstránené',
  deleteDeviceGroup: 'Skupina zariadenia úspešne odstránená',
  updateOperationCalendarEvent: 'Udalosť úspešne aktualizovaná',
  updateOperationEvent: 'Udalosť úspešne aktualizovaná',
  invalidateOperationEvent: 'Udalosť úspešne zneplatnená',
  deleteOperationCalendarEvent: 'Udalosť úspešne zmazaná',
  createDeliveryContract: 'Dlhodobý kontrakt bol úspešne vytvorený',
  updateDeliveryContract: 'Informácie o kontrakte boli úspešne upravené',
  assignDeliveryPoint: 'Odberné miesto bolo úspešne priradené ku kontraktu',
  assignDeliveryPointChange: 'Priradenie OOM úspešne zmenené',
  unassignDeliveryPoint: 'Odberné miesto bolo úspešne odobrané z kontraktu'
};

export default skEaiMessages;
